import { OddsFormat, useAuthUserSettings } from '@/hooks/use-auth-user-settings';

import { useIsPredictionsProduct } from './use-is-predictions-product';

// Get the user's odds format preference, defaulting to decimal. Classic Mode uses American odds.
export const useOddsFormat = () => {
    const { data: userSettings } = useAuthUserSettings();
    const isPredictions = useIsPredictionsProduct();
    if (isPredictions) {
        return OddsFormat.DECIMAL;
    }
    return userSettings?.odds_format ?? OddsFormat.DECIMAL;
};
